import React from "react";

const PLACEHOLDER_SUGGESTIONS = [
    "Your top streaming markets are shifting — see where to focus next.",
    "Spotify listeners grew this week — explore what drove it.",
    "Revenue insight: compare streaming income vs expenses.",
    "Fanbase growth signal in your top city — tap to explore.",
    "Playlist performance update — see what's trending for you.",
    "Cross-platform reach — discover your strongest channel.",
];

const OVERLAY_COPY = {
    link_artist: {
        title: "Link your artist to unlock insights",
        description:
            "Connect your artist profile so Amplitude can power personalized recommendations from your streaming and audience data.",
        cta: "Link Artist",
    },
    go_pro: {
        title: "Subscribe to unlock your personalized insights",
        description:
            "Get real-time recommendations powered by your streaming and audience data.",
        cta: "Go Pro",
    },
};

function PlaceholderCard({ text }) {
    return (
        <div className="flex items-center bg-theme_clr1 rounded-xl px-4 py-3 opacity-90">
            <div className="flex-1 text-white text-sm font-semibold blur-[3px] select-none">
                {text}
            </div>
            <span
                className="ml-4 flex items-center justify-center bg-[#fa6138] text-white rounded-full w-8 h-8 text-xl font-bold opacity-60 pointer-events-none"
                aria-hidden
            >
                +
            </span>
        </div>
    );
}

/**
 * @param {'link_artist'|'go_pro'} variant
 */
export default function AmplitudeSuggestionsLocked({ variant = "go_pro", onGoPro, onLinkArtist }) {
    const copy = OVERLAY_COPY[variant] || OVERLAY_COPY.go_pro;
    const handleCta = variant === "link_artist" ? onLinkArtist : onGoPro;

    return (
        <div className="relative h-full flex flex-col min-h-[320px] lg:min-h-0">
            <div className="sticky top-0 z-[1] bg-gradient-to-r from-theme_clr1 to-theme_clr2 text-white rounded-t-xl font-bold text-lg text-center p-2">
                Amplitude Suggestions
            </div>

            <div className="relative flex-1 rounded-b-xl overflow-hidden border border-slate-200 border-t-0">
                <div
                    className="flex flex-col gap-3 p-4 pt-4 pointer-events-none select-none"
                    aria-hidden
                >
                    {PLACEHOLDER_SUGGESTIONS.map((text, idx) => (
                        <PlaceholderCard key={idx} text={text} />
                    ))}
                </div>

                <div className="absolute inset-0 z-10 flex items-center justify-center bg-black/45 backdrop-blur-[2px] px-4">
                    <div className="w-full max-w-[260px] rounded-xl bg-white p-5 text-center shadow-lg">
                        <h3 className="text-theme_clr1 text-base font-bold mb-2 leading-snug">
                            {copy.title}
                        </h3>
                        <p className="text-xs text-slate-600 mb-4 leading-relaxed">
                            {copy.description}
                        </p>
                        <button
                            type="button"
                            onClick={handleCta}
                            className="btn-custom3 !py-2 !px-6 w-full text-sm font-bold uppercase"
                        >
                            {copy.cta}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
